import posthog from "posthog-js";

export const capturePosthogEvent = (eventName, params) => {
    posthog.capture(eventName, params);
};

export const initPosthog = (posthogKey, posthogHost) => {
    const isLocalEnvironment = window.location.href.includes('localhost') ||
        window.location.href.includes('127.0.0.1');
    if (isLocalEnvironment) {
        console.log('posthog initialized');
    } else {
        posthog.init(posthogKey, {
            api_host: posthogHost,
            capture_pageview: false,
            loaded: (instance) => {
                window.posthog = instance;
            },
        });
    }
};

export const posthogEvents = {
    AUTH_FORM_OPENED: '$auth-form-opened',
    AUTH_CALL_REQUEST: '$auth-call-request',
    AUTH_SMS_REQUEST: '$auth-sms-request',
    AUTH_LOGGED_IN: '$auth-logged-in',
    AUTH_LOGGED_OUT: '$auth-logged-out',
};
